import { RecordCommentsButton } from "@/components/common/comments/RecordCommentsButton";
import { ResourceName } from "@/types";

interface ClientCommentsButtonProps {
  clientId: string | undefined;
}

/**
 * Client-specific entry point for the comments drawer (ADR-052 S4). Thin wrapper
 * over the subject-agnostic RecordCommentsButton so the drawer/resize behavior has
 * one source of truth across every subject type (ADR-052 §8(f)).
 */
export const ClientCommentsButton = ({ clientId }: ClientCommentsButtonProps) => (
  <RecordCommentsButton subjectType={ResourceName.CLIENTS} subjectId={clientId} />
);
